<template>
  <loader v-bind="{ loading }">
    <div class="columns">
      <div class="column">
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </div>
    </div>
    <table class="table is-fullwidth is-hoverable">
      <thead>
        <tr>
          <th>Version</th>
          <th class="has-text-right">Last updated</th>
          <th class="has-text-right">Vulnerabilities</th>
          <th class="has-text-right">Environments</th>
          <th class="has-text-right">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="version in versions.data" :key="version.id">
          <td>{{ `${version.version_number}` }}<span v-if="version.update_version">.{{ version.update_version }}</span></td>
          <td class="has-text-right">
            <span v-if="version.last_cve_check">{{ version.last_cve_check | asCalendar }}</span>
            <span v-else>--</span>
          </td>
          <td class="has-text-right">
            <router-link :to="{
              name: 'version-vulnerabilities',
              params: {
                version: version.id,
                software: $route.params.software
              }}">
              {{ version.vulnerabilities_count }}
            </router-link>
          </td>
          <td class="has-text-right">{{ version.attributes_count }}</td>
          <td class="has-text-right">
            <action-button :disabled="!version.can_be_updated" @click="updateCvesForVersion(version)" class="is-small is-rounded is-warning">
              Update CVEs
            </action-button>
          </td>
        </tr>
      </tbody>
    </table>
    <pager 
      class="mb-1"
      :pageable="versions" 
      @nav="goToPage"
      jump-controls
      context="Version"/>
  </loader>  
</template>
<script>
import Paginator from '@/store/models/Paginator'
import { getPath } from '@/api/common'

export default {
  data: () => ({
    versions: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadVersions()
  },

  methods: {
    loadVersions() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.versions = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'software-versions',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'software-versions',
        params: {
          software: this.$route.params.software
        },
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    },
    updateCvesForVersion(version) {

    }
  },

  watch: {
    '$route': 'loadVersions'
  }
}
</script>